import React from "react";

import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Divider, Paper } from "@mui/material";
import MenuMessages from "./MenuListMessages";
import MessagePanelOpenCard from "./MessagePanelOpenCard";

const MessageDropdown = ({ anchorEl, messsageUnreadCount,setMessageMenu, setOpenMessagePanel,t }) => {
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
 
  const handleClose = () => {
    setMessageMenu(null);
  };

  return (
    <Popover
    
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Paper sx={{ p: 2 }} className="boxcontainermessage">
        <Typography variant="body1" fontWeight={"bold"}>
          {t("messages")}
        </Typography>
        <Divider />
        <MenuMessages />
        <MessagePanelOpenCard messsageUnreadCount={messsageUnreadCount} setOpenMessagePanel={setOpenMessagePanel} setMessageMenu={setMessageMenu} t={t} />
      </Paper>
    </Popover>
  );
};

export default MessageDropdown;
